<template>
  <topbar-element v-if="this.$store.state.UserInfo.token !='' "></topbar-element>
  <div class="row sn-main-content">
    <div v-if="this.$store.state.UserInfo.token !='' " class="col-md-3 col-lg-2" ><sidebar-element></sidebar-element></div>
    <div :class="{'col-md-9 col-lg-10 sn-content-col': this.$store.state.UserInfo.token !=''}"><router-view/></div>
  </div>
  
</template>

<script>
import TopbarElement from  '@/components/layout/TopbarElement.vue';
import SidebarElement from  '@/components/layout/SidebarElement.vue';

export default {
    components: {
        TopbarElement, SidebarElement
    },
    inject: ['cfg'],
}
</script>


<style>
#app {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.sn-main-content {
  margin-top:80px;
  text-align: left;
}

.sn-content-col {
  padding: 10px 10px 10px 10px ;
}


</style>
